module.exports = __webpack_public_path__ + "images/BBPSlogoaef5e117d4d19b0fd68d50c2040a7975.svg";